import React from "react";

const InnerHeader = ({ children }) => {
  return <div className="content-heading">{children}</div>;
};
export default InnerHeader;
